import { VentasDetalleRegionReciente } from "../../components";

const VentasRegionReciente = () => (
  <div>
    <VentasDetalleRegionReciente />
  </div>
);

export default VentasRegionReciente;
